import React, { useMemo } from 'react';
import { mdiVideoOutline, mdiFlaskOutline, mdiHelpCircleOutline } from '@mdi/js';
import styled from 'styled-components';
import { SkillIconPath } from '../../Icons/SkillIcon';
import { Stat } from './Stat';
export var CollectionStatType;
(function (CollectionStatType) {
    CollectionStatType["Skill"] = "skill";
    CollectionStatType["Lab"] = "virtual_lab";
    CollectionStatType["Assessment"] = "assessment";
    CollectionStatType["Video"] = "video";
    CollectionStatType["Question"] = "question";
    CollectionStatType["LiveLearning"] = "live-learning-session";
})(CollectionStatType || (CollectionStatType = {}));
const StatsContainer = styled.div `
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 2rem;
`;
export const CollectionStats = ({ stats, labelOverrides, onClick }) => {
    var _a, _b, _c, _d;
    const { skillCount, videoCount, labCount, questionCount } = useMemo(() => {
        return (stats !== null && stats !== void 0 ? stats : []).reduce((memo, stat) => {
            switch (stat.type) {
                case CollectionStatType.Skill:
                    memo.skillCount = stat.count;
                    break;
                case CollectionStatType.Video:
                    memo.videoCount = stat.count;
                    break;
                case CollectionStatType.Lab:
                    memo.labCount = stat.count;
                    break;
                case CollectionStatType.Question:
                    memo.questionCount = stat.count;
                    break;
            }
            return memo;
        }, {
            skillCount: 0,
            videoCount: 0,
            labCount: 0,
            questionCount: 0
        });
    }, [stats]);
    return (React.createElement(StatsContainer, null,
        React.createElement(Stat, { onClick: onClick, label: (_a = labelOverrides === null || labelOverrides === void 0 ? void 0 : labelOverrides.skill) !== null && _a !== void 0 ? _a : 'skill', icon: SkillIconPath, total: skillCount }),
        React.createElement(Stat, { onClick: onClick, label: (_b = labelOverrides === null || labelOverrides === void 0 ? void 0 : labelOverrides.video) !== null && _b !== void 0 ? _b : 'video', icon: mdiVideoOutline, total: videoCount }),
        React.createElement(Stat, { onClick: onClick, label: (_c = labelOverrides === null || labelOverrides === void 0 ? void 0 : labelOverrides.lab) !== null && _c !== void 0 ? _c : 'lab', icon: mdiFlaskOutline, total: labCount }),
        React.createElement(Stat, { onClick: onClick, label: (_d = labelOverrides === null || labelOverrides === void 0 ? void 0 : labelOverrides.question) !== null && _d !== void 0 ? _d : 'question', icon: mdiHelpCircleOutline, total: questionCount })));
};
//# sourceMappingURL=index.js.map